import React from "react";
import Swiper from "swiper";

class LinkedProducts extends React.Component {
  static defaultProps = {
    slidesToShow: 4
  };

  componentDidMount() {
    const sliderOpts = {
      slidesPerView: 4,
      threshold: 50,
      navigation: {
        nextEl: '.pdp-related-product__slider-nav--next',
        prevEl: '.pdp-related-product__slider-nav--prev',
        disabledClass: 'pdp-related-product__slider-nav--disabled'
      },
      breakpoints: {
        1300: {
          slidesPerView: 3
        },
        992: {
          slidesPerView: 2
        },
        720: {
          slidesPerView: 1
        }
      }
    };

    new Swiper("#" + this.props.sliderWrapperId, sliderOpts);
  }

  render() {
    const {title, children, sliderWrapperId} = this.props;

    return (
      <div className="pdp-related-product__inner">
        <h4 className="pdp-related-product__heading">{title}</h4>
        <div id={sliderWrapperId} className="swiper-container pdp-related-product__slider">
          <div className="swiper-wrapper">
            {children}
          </div>
          <div className="pdp-related-product__slider-nav pdp-related-product__slider-nav--prev"/>
          <div className="pdp-related-product__slider-nav pdp-related-product__slider-nav--next"/>
        </div>
      </div>
    );
  }
}

export default LinkedProducts;
